import { TabConfig } from "app/services/config/app-config";
import InfoIcon from "@mui/icons-material/Info";
import ListIcon from "@mui/icons-material/List";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ShareIcon from "@mui/icons-material/Share";
import AppsIcon from "@mui/icons-material/Apps";

export const getTabIcon = (tab: TabConfig) => {
    switch (tab.icon) {
        case "info":
            return <InfoIcon />;
        case "attributes":
            return <ListIcon />;
        case "specifications":
            return <AssignmentIcon />;
        case "relations":
            return <ShareIcon />;
        case "overview":
            return <ListIcon />;
        case "instances":
            return <AppsIcon />;
        default:
            return <InfoIcon />;
    }
};
